import React, { Component } from "react";
import { Input, Col, Label, FormGroup } from "reactstrap";
import { connect } from "react-redux";
import * as common from "../../Common/common";

class Calendar extends Component {
  makeOption = (min, max) => {
    const option = [];
    for (var n = min; n <= max; n++) {
      option.push(
        <option key={n} id={n}>
          {n}
        </option>
      );
    }
    return option;
  };
  makeYOption = (min, max, string) => {
    const option = [];
    for (var n = max; n >= min; n--) {
      option.push(
        <option key={n} id={n}>
          {n}
        </option>
      );
    }
    return option;
  };
  render() {
    const lastMonthDay = common.monthday(
      this.props.dateArr[0],
      parseInt(this.props.dateArr[1])
    );
    const optionYear = this.makeYOption(
      this.props.year.min,
      this.props.year.max,
      "年"
    );
    const optionMonth = this.makeOption(1, 12);
    const optionDay = this.makeOption(1, lastMonthDay);
    return (
      <FormGroup row>
        <Label for={this.props.labelFor} md={2} sm={12} xs={12}>
          {this.props.label}
        </Label>
        <Col md={6} sm={12} xs={12}>
          <FormGroup row>
            <Col sm={4} xs={4} style={{ margin: "0px 0px" }}>
              <Input
                type="select"
                value={this.props.dateArr[0]}
                name={this.props.labelFor}
                data-which-one={"y"}
                onChange={(event) =>
                  this.props.onChangeCalendar(
                    event,
                    this.props.cultivation,
                    "y"
                  )
                }
              >
                {optionYear}
              </Input>
            </Col>
            <span>−</span>
            <Col sm={3} xs={3}>
              <Input
                type="select"
                name={this.props.labelFor}
                data-which-one={"m"}
                value={`${Number(this.props.dateArr[1])}`}
                onChange={(event) =>
                  this.props.onChangeCalendar(
                    event,
                    this.props.cultivation,
                    "m"
                  )
                }
              >
                {optionMonth}
              </Input>
            </Col>
            <span>−</span>
            <Col sm={3} xs={3}>
              <Input
                type="select"
                name={this.props.labelFor}
                data-which-one={"d"}
                value={`${Number(this.props.dateArr[2])}`}
                onChange={(event) =>
                  this.props.onChangeCalendar(
                    event,
                    this.props.cultivation,
                    "d"
                  )
                }
              >
                {optionDay}
              </Input>
            </Col>
          </FormGroup>
        </Col>
      </FormGroup>
    );
  }
}

const mapStateToProps = (state) => ({
  crop: state.cropShow,
});

export default connect(mapStateToProps)(Calendar);
